// Cena — Dashboard (áudio ~18s)
// Os três cards de estatística REAIS ganham números fictícios que contam
// de 0 até o alvo; o spotlight (com blur de fundo + anel gradiente) varre
// card por card, um toast celebra os 15 resolvidos e a cena fecha
// apresentando o quadro da equipe (a próxima cena mergulha nele).
const MAIN = "[data-tour='main-content']";
const STAT_OPEN = "[data-tour='dash-stat-open']";
const STAT_PENDING = "[data-tour='dash-stat-pending']";
const STAT_CLOSED = "[data-tour='dash-stat-closed']";
const BOARD = "[data-tour='dash-board']";
const FULL = { position: "absolute", inset: 0 };

export default async function dashboard(ctx) {
	await ctx.waitFor(STAT_OPEN, 4000);

	// números fictícios por cima dos cards reais (CountUp de 0 até o alvo)
	ctx.mount("statOverlay", STAT_OPEN, {
		label: "Em atendimento",
		value: 3,
		colorKey: "open",
		style: FULL,
	});
	ctx.mount("statOverlay", STAT_PENDING, {
		label: "Aguardando",
		value: 1,
		colorKey: "pending",
		style: FULL,
	});
	ctx.mount("statOverlay", STAT_CLOSED, {
		label: "Finalizado",
		value: 15,
		colorKey: "closed",
		style: FULL,
	});
	await ctx.wait(700);

	// card 1 — em atendimento
	ctx.spotlight(STAT_OPEN);
	await ctx.cursorTo(STAT_OPEN, { duration: 900 });
	await ctx.wait(2600);

	// card 2 — aguardando
	ctx.spotlight(STAT_PENDING);
	await ctx.cursorTo(STAT_PENDING, { duration: 750 });
	await ctx.wait(2600);

	// card 3 — finalizados hoje (+ toast fixo, grande, embaixo no centro)
	ctx.spotlight(STAT_CLOSED);
	await ctx.cursorTo(STAT_CLOSED, { duration: 750 });
	const t = ctx.mount("toast", MAIN, {
		icon: "🏆",
		text: "15 resolvidos hoje!",
	});
	await ctx.wait(3200);
	ctx.unmount(t);
	await ctx.wait(300);

	// fecha apresentando o quadro da equipe
	ctx.spotlight(BOARD);
	await ctx.cursorTo(BOARD, { duration: 900 });
	await ctx.wait(3200);

	ctx.spotlight(null);
}
